import fondsStatistics from "@/mods/statistic/detailView/fondsStatistics";
export default {
  fondsStatistics,
};
